import i18n from 'constants/strings'
import { indexToDateChunk } from 'utils'

export const PERSON_DOB_API_FORMAT = 'YYYY-MM-DD'
export const PERSON_DOB_UI_FORMAT = 'DD MMM YYYY'

const currentYear = new Date().getFullYear()
const maxYearSpan = 100
const monthsIndices = Array.from(Array(12).keys())
const daysIndices = Array.from(Array(31).keys())
const yearsIndices = Array.from(Array(maxYearSpan).keys())

export const MONTHS = monthsIndices.map(i => indexToDateChunk(i))
export const DAYS = daysIndices.map(i => indexToDateChunk(i))
export const YEARS = yearsIndices.map(i => `${currentYear - i}`)

export const DAY_OPTIONS = DAYS.map((day, i) => ({
  value: day,
  label: `${Number(day)}`,
}))

export const MONTH_OPTIONS = MONTHS.map((month, i) => ({
  value: month,
  label: i18n.t(`strDates.monthsShort.${i}`),
}))

export const YEAR_OPTIONS = YEARS.map((year, i) => ({
  value: `${year}`,
  label: `${year}`,
}))
